import { render, staticRenderFns } from "./OrgTeamCard.vue?vue&type=template&id=7324b98e&scoped=true&"
import script from "./OrgTeamCard.vue?vue&type=script&lang=ts&"
export * from "./OrgTeamCard.vue?vue&type=script&lang=ts&"
import style0 from "./OrgTeamCard.vue?vue&type=style&index=0&id=7324b98e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7324b98e",
  null
  
)

export default component.exports